import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IForgotPasswordVerifyOTPResponse } from '../../../entity/interface/iAuthApis';

export interface IForgotPasswordVerifyOTPUseCase {
    execute(
        username: string,
        pinValue: string,
        verifyGuid: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordVerifyOTPResponse>;
}

export class ForgotPasswordVerifyOTPUseCase implements IForgotPasswordVerifyOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        pinValue: string,
        verifyGuid: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordVerifyOTPResponse> {
        return await this.authRepo.forgotPasswordVerifyOTP(username, pinValue, verifyGuid, apiToken, recaptchaToken);
    }
}
